import React, {useEffect, useState} from 'react';
import Footer from "@organisms/footer/footer";
import Metas from "@includes/metas";
import {UserContext} from "@providers/user";
import GoogleTagManager from "@includes/google.tag.manager";
import {isEmpty} from "@helpers/helpers";
import Investment from "@organisms/property/invest/investment";
import {handleShowInvestmentModalTrack} from "../organisms/property/invest/investment_tracks";
import {crispConfig} from "../../helpers/crisp_config";

export default function AppLayout({children, page, footerLinks, className, selectedCityId, propertyDealType, pageTitle, pageCanonicalLink, pageDescription, pageRobots, ogDescription, pageImages, footer = true, investment = true, investmentPageView, investmentPageSection, showCrispChat = false}) {
    const userContext = React.useContext(UserContext);
    const [investModalShow, setInvestModalShow] = useState(false);

    useEffect(() => {
        if (userContext.modality.show_invest_modal) {
            setInvestModalShow(true);

            let data = JSON.parse(JSON.stringify(userContext.modality));
            if (!isEmpty(data.event_position) && data.event_position === 'popup') {
                data['event_section'] = investmentPageSection;
                data['event_view'] = investmentPageView;
            }

            handleShowInvestmentModalTrack(data);
        }

    }, [userContext.modality]);

    useEffect(() => {
        crispConfig(userContext, showCrispChat);
    }, [userContext.check])

    return (
        <div id="appLayout" className={className ?? ''}>
            <Metas
                pageTitle={pageTitle}
                ogTitle={pageTitle}
                robots={pageRobots}
                descriptionMeta={pageDescription}
                ogDescription={ogDescription}
                pageImages={pageImages}
                originalCanonicalLink={pageCanonicalLink}
                canonicalLink={pageCanonicalLink}
                pageArticle=""/>

            {children}

            {
                (footer) ?
                    <Footer
                        page={page}
                        footerLinks={footerLinks}
                        selectedCityId={selectedCityId}
                        propertyDealType={propertyDealType}
                    />
                    : ''
            }

            {
                (!isEmpty(process.env.NEXT_PUBLIC_APP_GOOGLE_TAG_MANAGER)) ?
                    <GoogleTagManager/> : ''
            }

            {
                (!isEmpty(userContext) && !isEmpty(userContext.modality)) ?
                    <Investment
                        showFixedBell={investment}
                        city_id={userContext.modality.city_id}
                        page={userContext.modality.page}
                        isBadeSaba={userContext.modality.isBadeSaba}
                        investModalShow={investModalShow}
                        setInvestModalShow={setInvestModalShow}
                        eventSection={userContext.modality.event_section}
                        eventView={userContext.modality.event_view}
                        investmentPageView={investmentPageView} // used for drawer and popup
                        investmentPageSection={investmentPageSection} // used for drawer and popup
                    />
                    : ''
            }
        </div>
    )
}